/**
 * Video Player
 */

// Vendors
import $ from 'jquery';

// Play video
$('[data-video-play]').on('click', (event) => {
  if (!event) return;

  event.preventDefault();

  const videoId = $(event.currentTarget).data('video-id');
  const videoSource = $(event.currentTarget).data('video-source');
  const videoIframe = document.createElement('iframe');
  const videoSources = {
    youtube: `https://www.youtube.com/embed/${videoId}?modestbranding=1&autohide=1&showinfo=0&autoplay=1&rel=0`,
    vimeo: `https://player.vimeo.com/video/${videoId}?badge=0&byline=0&portrait=0&title=0&autoplay=1`
  };

  if (!videoSources[videoSource]) return;

  videoIframe.src = videoSources[videoSource];
  videoIframe.className = 'video-player__iframe';
  videoIframe.setAttribute('allowFullScreen', '');
  videoIframe.setAttribute('allow', 'autoplay');

  $(event.currentTarget)
    .closest('.video-player')
    .addClass('video-player--playing');
  $(event.currentTarget).closest('.video-player').append(videoIframe);
});
